import { render, staticRenderFns } from "./Loan.page.vue?vue&type=template&id=30c1c73e&scoped=true&"
import script from "./Loan.page.vue?vue&type=script&lang=js&"
export * from "./Loan.page.vue?vue&type=script&lang=js&"
import style0 from "./Loan.page.vue?vue&type=style&index=0&id=30c1c73e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c1c73e",
  null
  
)

export default component.exports